'use strict'

const $ = require('jquery')

class FloatingContactButton {
    constructor() {
        const button = $('.floating-contact-button')

        if (!button.length) {
            return
        }

        const footer = $('#footer')

        function getShowOffset() {
            return button.data('show-offset') ? parseInt(button.data('show-offset'), 10) : $(window).height()
        }

        function getHideOffset() {
            return button.data('hide-offset') ? parseInt(button.data('hide-offset'), 10) : 0
        }

        function onScroll() {
            const scroll_top = $(window).scrollTop()
            const viewport_bottom = scroll_top + $(window).height()
            const footer_top = footer.length ? footer.offset().top : Infinity

            const past_show_offset = scroll_top >= getShowOffset()
            const before_footer = viewport_bottom < footer_top - getHideOffset()

            button.toggleClass('is-visible', past_show_offset && before_footer)
        }

        function init() {
            window.addEventListener('scroll', onScroll)
            window.addEventListener('resize', onScroll)
            onScroll()
        }

        init()
    }
}

module.exports = FloatingContactButton
